import { Columns3, List } from 'lucide-react';
import { SegmentedControl } from '@up2stay/up2promo-ui';

export type LeadsViewMode = 'list' | 'boards';

type LeadsViewToggleProps = {
  value: LeadsViewMode;
  onChange: (next: LeadsViewMode) => void;
  labels: {
    list: string;
    board: string;
  };
  className?: string;
};

/** Liste | Board — thin domain wrapper over ui SegmentedControl. */
export function LeadsViewToggle({
  value,
  onChange,
  labels,
  className,
}: LeadsViewToggleProps) {
  return (
    <SegmentedControl
      ariaLabel={labels.list}
      value={value}
      onChange={onChange}
      className={className}
      itemClassName="h-auto gap-1.5 px-2.5 py-1.5 text-[12.5px]"
      options={[
        {
          value: 'list',
          label: (
            <>
              <List className="size-3.5 shrink-0" aria-hidden />
              {labels.list}
            </>
          ),
        },
        {
          value: 'boards',
          label: (
            <>
              <Columns3 className="size-3.5 shrink-0" aria-hidden />
              {labels.board}
            </>
          ),
        },
      ]}
    />
  );
}
